module.exports = "<div class=\"wrapper container-fluid clearfix\">\n\n   <external-header></external-header>\n\n  <!-- <h2 class=\"text-info\">External Layout</h2> -->\n\n  <div ui-view=\"externalContent\"></div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/layout/external-layout/external-layout.html
// module id = 390
// module chunks = 0